import DocumentForm from "../document/DocumentForm";
import { useParams } from "react-router";

export default function NewVehicleSetupDocument() {
  const { setupId } = useParams();
  return <DocumentForm ownerType={"SETUP"} ownerId={setupId} />;
}
